<h1 mat-dialog-title>Sezon</h1>
<div mat-dialog-content>
	<div class="mb-6">
		<div class="mb-3">
			<div class="col-sm">
				W tym miejscu będziemy później dodawać więcej funkcjonalnośći.<br />
				Choćby łączenie z wydarzeniami, statystki,informacje ile np. jest doków itd.
			</div>
			<div class="col-sm">
				Transport:
				<div class="btn btn-link" (click)="transport('departure')">Wyjazd</div>
				<div class="btn btn-link" (click)="transport('return')">Powrót</div>
			</div>
			<div class="col-sm">
				<a routerLink="/accommodations/{{ season.accommodation.lower }}" target="_blank">
					Plik Kwaterunkowy (brakuje jeszcze wybór konkretnego produktu)</a
				>
			</div>
		</div>
	</div>
</div>
